<template>
  <div>
    <common-dialog
      ref="dialog"
      width="600px"
      :show-save-button="$permission.canEdit()"
      unit="资源类别"
      edit-title
      id-key="RecordId"
      :data="data"
      form-label-width="105px"
      :form-rules="rules"
      :save-func="api.save"
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      close-on-saved
      :before-save="onBeforeSave"
      @closed="onClosed"
      @close-saved="$emit('close-saved')"
    >
      <!--width是整个窗口的宽度-->
      <template slot="form">
        <el-row>
          <el-col :span="isMB ? 24 : 12">
            <!--这句用于判断手机和电脑的不同显示，如果是手机则24表示全屏，如果是电脑，则12表示占一半-->
            <el-form-item label="资源类别" prop="TypeName">
              <el-input
                v-model="data.TypeName"
                placeholder="请填写资源类别"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="isMB ? 24 : 12"> </el-col>
        </el-row>
        <el-row>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="序号" prop="OrderId">
              <el-input-number v-model="data.OrderId" :min="0" />
            </el-form-item>
          </el-col>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="状态" prop="State">
              <el-radio-group v-model="data.State">
                <el-radio :label="1">启用</el-radio>
                <el-radio :label="0">停用</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
      <template #footer v-if="!$permission.canEdit()">
        <el-button @click="close">关 闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>
  <script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      data: {
        //每次刷新页面后各编辑框的初始值，例如某个字段如果不清空，继承上一次编辑的内容，则不赋予初值就好
        RecordId: 0,
        TypeName: "",

        OrderId: 0,
        State: 1,
      },
      api: require("@/api/resources/type").default,
      isMB: this.$store.state.isMB,
      rules: {
        TypeName: [{ required: true, message: "资源类别不能为空" }], //TermName这个名称就必须和上面各类录入框的prop属性值一致，就是控制同名的录入框的必填
      },
    };
  },
  methods: {
    onCreateOpened(row) {
      this.api.getMaxOrderId().then((res) => {
        if (res.Code == 0) this.data.OrderId = res.Data;
      });
    },
    onEditOpened(row) {},
    onBeforeSave() {},
    onClosed() {},
  },
};
</script>